import * as Yup from 'yup';
export const initialNavigationValues = {
    sequence: 0,
    name: '',
    icon: '',
    route: '',
    description: '',
    permissions: [],
};
export const navigationSchema = Yup.object().shape({
    sequence: Yup.string(),
    name: Yup.string(),
    icon: Yup.string(),
    route: Yup.string(),
    description: Yup.string(),
});
//# sourceMappingURL=navigation.js.map